module.exports = __webpack_public_path__ + "img/main_hsw.ae6b7ef1.jpg";